(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yf-header"]) return;
  try {
    
  if (!customElements.get('yf-cart-link')) {
    customElements.define('yf-cart-link', class extends HTMLElement {
      connectedCallback() {
        this.syncLabel = () => {
          const label = this.querySelector('.yf-cart-label');
          if (label && label.textContent !== this.dataset.label) {
            label.textContent = this.dataset.label || '';
          }
        };
        this.syncLabel();
        this.observer = new MutationObserver(this.syncLabel);
        this.observer.observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  if (!customElements.get('yf-search-typing')) {
    customElements.define('yf-search-typing', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.input = this.querySelector('input[type="search"]');
        if (!this.input || this.dataset.enabled !== 'true') return;
        this.original = this.input.getAttribute('placeholder') || '';
        let phrases;
        try {
          phrases = JSON.parse(this.dataset.phrases || '[]');
        } catch {
          return;
        }
        if (!Array.isArray(phrases)) return;
        this.phrases = [...new Set([this.original, ...phrases]
          .filter((phrase) => typeof phrase === 'string')
          .map((phrase) => phrase.trim())
          .filter(Boolean))];
        if (this.phrases.length < 2) return;
        this.controller = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.canAnimate = () => this.isConnected &&
          !document.hidden && !this.motion.matches &&
          document.activeElement !== this.input && !this.input.value;
        this.reset = () => {
          window.clearTimeout(this.timer);
          this.index = 0;
          this.position = Array.from(this.phrases[0]).length;
          this.deleting = true;
          this.input.setAttribute('placeholder', this.original);
          if (this.canAnimate()) this.timer = window.setTimeout(this.tick, 2400);
        };
        this.tick = () => {
          if (!this.canAnimate()) {
            this.reset();
            return;
          }
          const letters = Array.from(this.phrases[this.index]);
          let delay;
          if (this.deleting) {
            this.position = Math.max(0, this.position - 1);
            this.input.setAttribute('placeholder', letters.slice(0, this.position).join(''));
            delay = 32;
            if (this.position === 0) {
              this.index = (this.index + 1) % this.phrases.length;
              this.deleting = false;
              delay = 300;
            }
          } else {
            this.position += 1;
            this.input.setAttribute('placeholder', letters.slice(0, this.position).join(''));
            delay = 65;
            if (this.position >= letters.length) {
              this.deleting = true;
              delay = 2400;
            }
          }
          this.timer = window.setTimeout(this.tick, delay);
        };
        const options = { signal: this.controller.signal };
        ['focus', 'blur', 'input', 'change'].forEach((eventName) => {
          this.input.addEventListener(eventName, this.reset, options);
        });
        document.addEventListener('visibilitychange', this.reset, options);
        this.motion.addEventListener('change', this.reset, options);
        this.reset();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = null;
        if (this.input && this.original !== undefined) {
          this.input.setAttribute('placeholder', this.original);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yf-image-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yf-image-slider')) {
    customElements.define('yf-image-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.yf-image-slider__track');
        this.slides = [...this.querySelectorAll('.yf-image-slider__slide')];
        this.dots = [...this.querySelectorAll('[data-slide-index]')];
        if (!this.track || !this.slides.length) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.index = 0;
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.show(this.index + Number(button.dataset.direction)), options));
        this.dots.forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.slideIndex)), options));
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.setActive(Math.round(this.track.scrollLeft / this.track.clientWidth)), 100);
        }, { passive: true, signal: this.events.signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const selected = event.target.closest('[data-slide-id]');
          const index = this.slides.indexOf(selected);
          if (index >= 0) this.show(index, false);
        }, options);
        this.resize = new ResizeObserver(() => this.show(this.index, false));
        this.resize.observe(this.track);
        const controls = this.querySelector('.yf-image-slider__controls');
        if (controls) controls.hidden = false;
        this.setActive(0);
      }
      show(index, animate = true) {
        index = (index + this.slides.length) % this.slides.length;
        const smooth = animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.slides[index].offsetLeft - this.slides[0].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        this.setActive(index);
      }
      setActive(index) {
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        const counter = this.querySelector('.yf-image-slider__counter');
        if (counter) counter.textContent = `${this.index + 1} / ${this.slides.length}`;
      }
      disconnectedCallback() {
        this.events?.abort();
        this.resize?.disconnect();
        clearTimeout(this.scrollTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yf-product-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yf-product-description')) {
    customElements.define('yf-product-description', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-collapsible') || this.observer) return;
        this.body = this.querySelector('.yf-product-details__body');
        this.body.querySelectorAll('h1,h2,h3,h4').forEach(heading => {
          if (!heading.textContent.trim() && !heading.querySelector('img,svg,video,iframe')) heading.remove();
        });
        this.button = this.querySelector('button');
        this.expanded = false;
        this.update = () => {
          const limit = parseFloat(getComputedStyle(this).getPropertyValue('--yf-description-preview')) || 480;
          const long = this.body.scrollHeight > limit + 40;
          this.button.hidden = !long;
          this.classList.toggle('is-collapsed', long && !this.expanded);
        };
        this.button.onclick = () => {
          this.expanded = !this.expanded;
          this.button.setAttribute('aria-expanded', String(this.expanded));
          this.classList.toggle('is-expanded', this.expanded);
          this.update();
          if (!this.expanded) this.scrollIntoView({ block:'nearest', behavior:'auto' });
        };
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.body);
        this.update();
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.button) this.button.onclick = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yf-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yf-product-rail')) {
    customElements.define('yf-product-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.yf-products__grid');
        this.controls = this.querySelector('.yf-products__controls');
        if (!this.track || !this.controls) return;
        this.events = new AbortController();
        this.buttons = [...this.controls.querySelectorAll('button')];
        const options = { signal: this.events.signal };
        this.buttons.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.direction)), options));
        this.track.addEventListener('scroll', () => this.update(), { passive:true, signal:this.events.signal });
        this.track.addEventListener('keydown', event => {
          if (event.target === this.track && ['ArrowLeft','ArrowRight'].includes(event.key)) {
            event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      move(direction) {
        const item = this.track.firstElementChild;
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = item.getBoundingClientRect().width + gap;
        const count = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
        this.track.scrollBy({ left: direction * step * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 3;
        this.buttons[0].disabled = this.track.scrollLeft < 3;
        this.buttons[1].disabled = this.track.scrollLeft >= max - 3;
      }
      disconnectedCallback() { this.events?.abort(); this.resize?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
